import {Component, inject, OnInit} from '@angular/core';
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {Observable} from "rxjs";
import {
  RegulationPolicy, RegulationPolicyTypeEnum
} from "../../../store/entities/system-configurations/regulation-policy/regulation-policy.model";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {
  GET_ALL_REGULATIONS_AND_POLICIES
} from "../../../store/entities/system-configurations/regulation-policy/regulation-policy.graphql";
import {AttachmentService} from "../../../services/attachment.service";

@Component({
  selector: 'app-guest-policy-regulations',
  templateUrl: './guest-policy-regulations.component.html',
  styleUrl: './guest-policy-regulations.component.scss'
})
export class GuestPolicyRegulationsComponent implements OnInit {
  activeUid: string;
  selectedPolicy:RegulationPolicy;
  base64String: string;
  policies$: Observable<RegulationPolicy[]>
  store = inject(Store<AppState>)
  attachmentService = inject(AttachmentService);

  ngOnInit() {

    this.policies$ = this.store.select(selectStoreItems(StoreItemEntity.regulationPolicy));
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      query: GET_ALL_REGULATIONS_AND_POLICIES,
      entity: StoreItemEntity.regulationPolicy,
      filtering: {
        documentType: RegulationPolicyTypeEnum.PortalRegulations
      },
    }));
  }

  async setActiveUid(policy?: RegulationPolicy) {
    this.activeUid = policy?.uniqueId;
    this.selectedPolicy = policy;
    if (!!this.activeUid) {
      const response = await this.attachmentService.readAttachment(policy?.file?.filePath);
      this.base64String = response?.base64String;
      this.scrollToContainer('viewPoint');
    }
  }


  scrollToContainer(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  }
}
